import { IndexFields } from './index-fields';

export class MoveWorkItemDto {
  workItemId: number = 0;
  fromQueueId: number = 0;
  toQueueId: number = 0;
  toQueueName: string = '';
  userGpid: string = '';
  workflowId: number = 0;
  systemId: number = 0;
  indexingFields: IndexFields[] = [];
  transitionRuleVerification: boolean = false;
  queueVerification: boolean = false;
  retainForwardingUser: boolean = false;
  isAdvDocApprovalFromWebsite: boolean = false;
  workitemNotes: string = '';
  documentId: number = 0;
  workFlowAction: number = 0;
  queueType: number = 0;
}

export interface NextWorkItem {
  userGpid: string;
  systemId: number;
  workflowQueueId: number;
  workflowId: number;
  nextWorkitemSelectedComboValue: string;
  source: string;
}

export interface SaveDocHistoryDto {
  userGpid: string;
  systemId: number;
  documentId: string;
  fieldName: string | null;
  action: string;
  oldValue: string | null;
  newValue: string | null;
  comments: string;
  createdDate: string | null;
}
